import Antd from 'ant-design-vue';
import Vue from 'vue';
import VueApollo from 'vue-apollo';

import App from '@/vue/App.vue';
import router from '@/vue/router';
import store from '@/vue/store';

import 'ant-design-vue/dist/antd.less';

import * as CoreApp from '@/delivery/app';
import firebaseConfig from '@/delivery/config/firebase';
import apolloClient from '@/infrastructure/api/apollo';

Vue.config.productionTip = false;

const coreApp = new CoreApp.CoreApp(firebaseConfig, apolloClient);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(Antd);
Vue.use(VueApollo);
Vue.use(CoreApp.install, { app: coreApp });

coreApp.start((err, status, user) => {
  if (user) {
    store.commit('setUser', user);
  }

  router.beforeEach((to, from, next) => {
    const currentUser = store.state.user;
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) {
      // page requires auth but no logged in user; redirect to login
      next('login');
    } else if (currentUser !== null && to.name === 'login') {
      // user is logged in and navigating to login; redirect to home
      next('home');
    } else {
      next();
    }
  });

  new Vue({
    apolloProvider,
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app');
});

